import RemoteCache from './RemoteCache';

const globalBannerFallback = require('./hfFallBacks/globalBanner.fallback.ts');

export const BANNER_TYPES = {
  PDP: 'pdpbanners',
  SEARCH: 'searchbanners',
  STANDARD: 'standardbanners'
};

export const PAGE_TYPE_BANNERS = {
  product: BANNER_TYPES.PDP,
  search: BANNER_TYPES.SEARCH,
  get: function(pageType: string): string {
    return this[pageType as keyof object] || BANNER_TYPES.STANDARD;
  }
};

export const BANNER_PAGES = [BANNER_TYPES.PDP, BANNER_TYPES.SEARCH, BANNER_TYPES.STANDARD];

const createBannerUrl = (siteMeta: SiteMeta) =>
  `${siteMeta.mafiaUrl}/zcs/getSlots?pageLayout=GlobalBanner&pageName=${siteMeta.page}&siteId=${siteMeta.siteId}&subsiteId=${siteMeta.subsiteId}`;

interface SiteMeta {
  page: string;
  mafiaUrl: string;
  siteId: number;
  subsiteId: number;
}

export const fetchGlobalBannerData = (siteMeta: SiteMeta, remoteCache: RemoteCache, cookies?: any) => {
  const globalBannerPromises = [];
  const currentPage = PAGE_TYPE_BANNERS.get(siteMeta.page);
  globalBannerPromises.push(remoteCache.get(createBannerUrl({ ...siteMeta, page: currentPage }), globalBannerFallback, cookies));
  BANNER_PAGES.forEach(page => {
    if (page !== currentPage) {
      globalBannerPromises.push(remoteCache.get(createBannerUrl({ ...siteMeta, page }), globalBannerFallback, cookies));
    }
  });

  return globalBannerPromises;
};
